<template>
  <FormBox>
    <!-- 选择器 -->
    <el-select
      v-if="type === 'selector'"
      class="selector"
      :value="$attrs.value"
      :placeholder="placeholder"
      :multiple="multiple"
      :disabled="disabled"
      @change="onChange"
    >
      <el-option
        v-for="item in selectorList"
        :key="item[alias.value]"
        :value="item[alias.value]"
        :label="item[alias.label]"
      />
    </el-select>
    <!-- 级联选择器 -->
    <el-cascader
      v-if="type === 'cascader'"
      class="selector"
      :value="$attrs.value"
      :options="selectorList"
      :props="alias"
      :placeholder="placeholder"
      :disabled="disabled"
      @change="onChange"
    />
  </FormBox>
</template>

<script>
import FormBox from './FormBox'

export default {
  model: {
    prop: 'value',
    event: 'onChange'
  },
  components: {
    FormBox
  },
  props: {
    type: {
      type: String,
      default: 'selector'
    },
    selectorList: {
      type: Array,
      default: () => []
    },
    alias: {
      type: Object,
      default: () => {
        return {
          value: 'id',
          label: 'name'
        }
      }
    },
    multiple: Boolean,
    placeholder: String,
    onChangeFilter: Function,
    disabled: Boolean
  },
  methods: {
    onChange (val) {
      this.onChangeFilter
        ? this.$emit('onChange', this.onChangeFilter(val))
        : this.$emit('onChange', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.selector {
  width: 260px;
}
</style>
